/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { horizontalGridlinesStyles } from './themes/GanttStyles.css';

type Props = {
  width: number;
  height: number;
  positions: number[];
};

export function GanttHorizontalGridlinesLayer({ width, height, positions }: Props) {
  const cmd = positions.map((p) => `M0,${p} H${width}`).join(' ');
  return (
    <svg width={width} height={height}>
      <path class={horizontalGridlinesStyles.base} d={cmd} />
    </svg>
  );
}
